<button
  [type]="type"
  [disabled]="disabled"
  (click)="onClickButton()"
  class="font-bold min-w-[140px] h-input-height-phone for-laptop-up:h-input-height-laptop px-6 text-white rounded-3xl bg-buttonFilledDefault hover:bg-buttonFilledHover focus:bg-buttonFilledFocus focus:outline focus:outline-outlineFocus focus:hover:bg-buttonFilledHover disabled:focus-none disabled:outline-none disabled:bg-buttonFilledDisabled disabled:text-buttonTextDisabled disabled:cursor-not-allowed"
  [style.width]="width"
  [style.height]="height"
  [style.fontSize]="fontSize"
>
  <ng-content></ng-content>
</button>
